import { render } from "./ReplaceItems.vue?vue&type=template&id=7deb4b6f"
import script from "./ReplaceItems.vue?vue&type=script&lang=js"
export * from "./ReplaceItems.vue?vue&type=script&lang=js"
script.render = render

export default script